import { useEffect } from 'react';
import Head from 'next/head';
import { loadAlucard, startPractice } from '@lib/alucard';

const Practice = () => {
  useEffect(() => {
    loadAlucard(startPractice);
  }, []);

  return (
    <>
      <Head>
        <title>전략게임 튜토리얼</title>
      </Head>
      <link rel="stylesheet" href="/assets/interview/resources/css/interview2.css" />
    </>
  );
};

export default Practice;
